// Whether Digital Waste Tracking is switched on for the current company, and in
// which mode. Admin-only: for anyone else the query never runs and the answer is
// always "off", so DWT screens, filters and actions simply do not appear.

import { useQuery } from '@tanstack/react-query';
import { fetchDwtSettings } from '../api/dwtSettings';
import { useAuthStore } from '../store/authStore';

export type DwtModeName = 'off' | 'manual' | 'auto_on_approval';

export interface DwtModeInfo {
  /** Admin, feature enabled and mode not "off". */
  on: boolean;
  mode: DwtModeName;
  loading: boolean;
}

export function useDwtMode(): DwtModeInfo {
  const role = useAuthStore((s) => s.user?.role ?? null);
  const isAdmin = role === 'admin';
  const q = useQuery({
    queryKey: ['dwt', 'settings'],
    queryFn: fetchDwtSettings,
    enabled: isAdmin,
    staleTime: 60_000,
    retry: false,
  });
  if (!isAdmin) return { on: false, mode: 'off', loading: false };
  const d = q.data;
  const mode: DwtModeName = d?.dwt_mode ?? 'off';
  return { on: d !== undefined && d.enabled && mode !== 'off', mode, loading: q.isLoading };
}
